import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MediaMatcher } from '@angular/cdk/layout';
import { Menu, MenuItems } from '../../../shared/menu-items/menu-items';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Store } from '@ngrx/store';
import { setEventSubmenu } from 'src/app/core/state/general-state/general.actions';
import { Router } from '@angular/router';
import { setAccountIndex, setClientAccounts, setClientAccountSelected, setLinkedAccounts } from 'src/app/core/state/auth-state/auth.actions';
import { LoginService } from 'src/app/services/login/login.service';
import { forkJoin, of, Subscription } from 'rxjs';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { environment } from 'src/environments/environment';
import { getTenant, getClientData } from 'src/app/core/state/auth-state/auth.selectors';
import { LoadingService } from 'src/app/shared/loading/loading.service';
import { AccountTypeService } from './../../../services/account-type/account-type.service';
import { AccountsTypes, ConstatsRoutes } from 'src/app/utils/consts';
import { MixpanelService } from 'src/app/services/mix-panel/mix-panel.service';
import * as moment from 'moment';
import { UserAccountInfo } from 'src/app/models/user-account/account-data';
import { ConfigApp } from 'src/app/utils/configApp';
import { getConfigs } from 'src/app/core/state/general-state/general.selectors';
import { IProfilePermissions } from 'src/app/models/profiles-accesses/profile-permissions';
import { IUserManagers } from 'src/app/models/user-account/user-data';
import { LinkedAccountData } from 'src/app/models/standby/linked-account';
import { StandbyService } from 'src/app/services/standby/standby.service';
import { TenantService } from 'src/app/services/tenant/tenant.service';
import { MatDialog } from '@angular/material/dialog';
import { IncomeReportInfoDialogComponent } from '../../../dialogs/income-report-info-dialog/income-report-info-dialog.component';
import { AccountNameDialogComponent } from 'src/app/dialogs/account-name-dialog/account-name-dialog.component';
import { switchMap } from 'rxjs/operators';
import { BankingService } from 'src/app/services/banking/banking.service';
import Swal from 'sweetalert2';
import { AccountNameWarningDialogComponent } from 'src/app/dialogs/account-name-warning-dialog/account-name-warning-dialog.component';


@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: []
})
export class AppSidebarComponent implements OnInit, OnDestroy {
    @Output() newItemEvent = new EventEmitter<boolean>();
    @Input() snavFull: any;

    miniSideBar = false;
    image: any = null;
    name: string = "User Name";
    menuName: string = "User Name";

    public config: PerfectScrollbarConfigInterface = {};
    mobileQuery: MediaQueryList;

    sysSettings: any;
    private _mobileQueryListener: () => void;
    status = true;

    itemSelect: number[] = [];
    parentIndex = 0;
    childIndex = 0;
    permissions: IProfilePermissions | null = null;
    configsApp: any;
    subscription: Subscription = new Subscription();
    logo: any;
    tenant: string = '';
    icon: any;
    showSubnavBody: boolean = true;
    accounts: Array<UserAccountInfo> = [];
    selectedAccount: UserAccountInfo | null = null;
    open: boolean = false;
    isEscrow: boolean = false;
    linkedAccounts: LinkedAccountData[] = []

    menu: Array<Menu> = [];

    managerIndexView = 0;
    managers: IUserManagers[] = [];

    constructor(
        changeDetectorRef: ChangeDetectorRef,
        media: MediaMatcher,
        public menuItems: MenuItems,
        private store: Store,
        private router: Router,
        private loginService: LoginService,
        private settingsService: SettingsService,
        private loadingService: LoadingService,
        private AccountTypeService: AccountTypeService,
        private mixpanelService: MixpanelService,
        private standbyService: StandbyService,
        private tenantService: TenantService,
        private dialog: MatDialog,
        private bankingService: BankingService
    ) {
        this.mobileQuery = media.matchMedia('(min-width: 960px)');
        this._mobileQueryListener = () => {
            if ((this.mobileQuery.matches && this.miniSideBar) ||
                (!this.mobileQuery.matches && !this.miniSideBar)) {
                this.menuAction();
            }
            changeDetectorRef.detectChanges();
        };
        this.mobileQuery.addListener(this._mobileQueryListener);

        this.store.select(getClientData).subscribe(data => {

            if (data) {
                this.menu = this.menuItems.getMenuitem(data.wealth ? AccountsTypes.WEALTH : AccountsTypes.DEFAULT);
                const namesSplited = data.client?.name.split(" ") ?? [];
                const fallbackName = data.client ? `${namesSplited[0]} ${namesSplited[namesSplited.length - 1]}` : "";
                const displayName = data.selectedAccount?.displayName;
                this.name = displayName?.trim() ? displayName : fallbackName;
                this.menuName = fallbackName;
                this.accounts = data.accounts;
                this.selectedAccount = data.selectedAccount;
                this.permissions = data.selectedAccount?.operatorConfigProfile.permission ?? null;
                this.linkedAccounts = data.linkedAccounts;
            }
        });

        this.subscription.add(this.store.select(getTenant).subscribe((tenant) => {
            if (tenant)
                this.tenant = tenant;
            this.getBrandAssets();
        }));

        this.subscription.add(this.store.select(getConfigs).subscribe((configs) => {
            if (configs) {
                this.configsApp = configs;
            }
        }));

        this.loginService.getClientProfile().subscribe(x => {
            if (x && (x.type === 'image/png' || x.type === 'image/jpeg')) {
                const reader = new FileReader();

                reader.onload = () => {
                    const img = new Image();
                    img.onload = () => {
                        this.image = reader.result;
                    };
                    img.onerror = () => {
                        this.image = null;
                    };
                    img.src = reader.result as string;
                };

                reader.readAsDataURL(x);
            }
        });
    }

    ngOnInit(): void {
        if (!this.mobileQuery.matches && !this.miniSideBar) {
            this.menuAction();
        }
    }

    setClickedRow(i: number, j: number) {
        this.parentIndex = i;
        this.childIndex = j;
    }

    subClickEvent() {
        this.status = true;
    }

    scrollToTop() {
        document.querySelector('.page-wrapper')?.scroll({
            top: 0,
            left: 0
        });
    }

    getBrandAssets() {
        const cfg = environment.tenants.find(t => t.name === this.tenant);

        if (cfg) {
            this.icon = cfg.icon;
            this.logo = cfg.logo;
        }
    }

    validateItemMenu(menuName: string): boolean {
        return ConfigApp.validateItemMenu(menuName, this.configsApp, this.permissions, this.selectedAccount?.type ?? "", this.linkedAccounts);
    }

    validateSubItemMenu(menuName: string): boolean {
        return ConfigApp.validateSubItemMenu(menuName, this.configsApp, this.permissions, this.selectedAccount?.type ?? '');
    }

    menuAction() {
        this.miniSideBar = !this.miniSideBar;
        this.newItemEvent.emit(this.miniSideBar);
    }

    getIcon(icon: IconProp) {
        return icon;
    }

    openAccountNamingDialog(): void {
        const dialogRef = this.dialog.open(AccountNameDialogComponent, {
            width: '620px',
            height: '456px',
            data: this.selectedAccount
        });

        dialogRef.afterClosed().pipe(
            switchMap((result) => {
                if (result.status == "error") {
                    Swal.fire("Erro", "Falha ao atualizar apelido! Tente novamente mais tarde", "error");
                    return of(null);
                }

                if (result === 'Canceled by user') {
                    return of(null);
                }

                if (result.status === 'success') {
                    Swal.fire("Sucesso", "Apelido atualizado com sucesso!", "success");
                }

                return forkJoin({
                    accounts: this.bankingService.getAccounts(),
                    selectedAccount: this.bankingService.getBankingAccount()
                });
            })
        ).subscribe((result: any) => {
            if (result === null) return;

            this.store.dispatch(setClientAccounts({ accounts: result.accounts }));
            this.store.dispatch(setClientAccountSelected({ account: result.selectedAccount[0] }));
        });
    }

    logout() {
        this.loginService.logout();
    }

    onOpenedSubmenu() {
        this.store.dispatch(setEventSubmenu({ eventName: 'opened' }));
    }

    onClosedSubmenu() {
        this.store.dispatch(setEventSubmenu({ eventName: 'closed' }));
    }

    formatRouterLink(param1: string, param2: string, param3: string) {
        return '/' + param1 + '/' + param2 + '/' + param3;
    }

    setSelectedSubmenu(partialUrl: string) {
        if (this.router.url == partialUrl) {
            return 'selected'
        } else {
            return '';
        }
    }

    closeMenu() {
        this.snavFull.toggle();
    }

    closeAccounts() {
        this.open = false
    }

    closeHeaderSubnav(event: any, childItem: any) {
        event.stopPropagation();
        this.showSubnavBody = !this.showSubnavBody;
        childItem.active = !childItem.active;
    }

    showPerfil() {
        this.router.navigate(['admin/perfil'])
    }

    getInitialFromName(): string {
        let nameAux = (this.name.trim().split(" ", 2));
        let alias = "";

        nameAux.forEach(element => {
            alias += element[0];
        });

        return alias;
    }

    getAccountIndex(account: any) {
        switch (account) {
            case 'Conta Dependente':
                return 'DEPENDENT';
            case 'Conta Escrow':
                return 'ESCROW';
            default:
                return 'MAIN'
        }
    }

    chosenAccount(index: number) {
        this.selectedAccount = this.accounts[index];
        this.router.navigate([ConstatsRoutes.CCCOBRANCAENVIADAS]).then(() => {
            if (this.shouldWarnAboutDisplayName(this.selectedAccount!)) {
                this.openWarningAccountDisplayName();
            }
        });
        this.open = false;
        this.store.dispatch(setClientAccountSelected({ account: this.selectedAccount! }));
        this.store.dispatch(setAccountIndex({ account: this.selectedAccount!.accountIndex }));
        this.getLinkedAccounts(this.selectedAccount.operatorConfigProfile.userHolderTaxId);
    }

    getMenu(type: AccountsTypes): void {
        this.menu = this.menuItems.getMenuitem(type);
    }

    openPopUp() {
        this.open = !this.open
    }

    track(menuItem: string): void {
        if (menuItem.includes("Cobrança Avançada")) {
            this.mixpanelService.track("IB_Latest_" + menuItem);
        }
    }

    ngOnDestroy(): void {
        this.mobileQuery.removeListener(this._mobileQueryListener);
        this.subscription.unsubscribe();
    }

    mailTo(email: string) { }

    getLinkedAccounts(holderTaxId: string): void {
        this.standbyService.getLinkedAccounts({ holderTaxId })
            .subscribe((response) => {
                if (response.data && response.data.length > 0) {
                    this.store.dispatch(setLinkedAccounts({ accounts: response.data }));
                } else {
                    this.store.dispatch(setLinkedAccounts({ accounts: [] }));
                }
            },
                (error) => {
                    console.log(error)
                    this.store.dispatch(setLinkedAccounts({ accounts: [] }));
                }
            );
    }

    private shouldWarnAboutDisplayName(account: UserAccountInfo): boolean {
        const key = `warningAccountDisplayNameDismissed_${account.accountIndex}`;
        const dismissed = sessionStorage.getItem(key);

        return !account.displayName && !dismissed;
    }

    openWarningAccountDisplayName(): void {
        const dialogRef = this.dialog.open(AccountNameWarningDialogComponent, {
            width: '620px',
            height: '456px'
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result === 'openAccountNameDialog') {
                this.openAccountNamingDialog();
            }

            if (result === 'cancel') {
                const key = `warningAccountDisplayNameDismissed_${this.selectedAccount?.accountIndex}`;
                sessionStorage.setItem(key, 'true');
            }
        });
    }

    getAccountNumber(account: UserAccountInfo | null): string | null {
        if (!account) {
            return null;
        }
        return account.account?.slice(0, -1).concat('-').concat(account.account?.slice(-1));
    }
}
